// extracted by mini-css-extract-plugin
var _1 = "pfx-Account-module__account-fields--plB0s";
var _2 = "#000";
var _3 = "1260px";
var _4 = "1020px";
var _5 = "668px";
var _6 = "1550px";
var _7 = "pfx-Account-module__button--Wby08";
var _8 = "1140px";
var _9 = "940px";
var _a = "100%";
var _b = "15px";
var _c = "620px";
var _d = "#f53535";
var _e = "rgba(0,0,0,.2)";
var _f = "pfx-Account-module__delete-account--aXTDd";
var _10 = "rgba(255,255,255,.38)";
var _11 = ".38";
var _12 = "pfx-Account-module__download--Cud7j";
var _13 = "pfx-Account-module__empty-placeholder--ypqlm";
var _14 = "rgba(255,255,255,.2)";
var _15 = "#0025ff";
var _16 = "pfx-Account-module__glitch-anim--x4HLb";
var _17 = "pfx-Account-module__glitch-anim-2--Ycxt7";
var _18 = "#f60";
var _19 = "#41ead4";
var _1a = "#2cdd78";
var _1b = "#66ab23";
var _1c = "#f5f5f5";
var _1d = "#c3c3c3";
var _1e = "#ececec";
var _1f = "#252525";
var _20 = "#272727";
var _21 = "#c6c6c5";
var _22 = "#333";
var _23 = "#3c3c3c";
var _24 = "#9c9b9b";
var _25 = "#8c8c8c";
var _26 = "#6f6f6e";
var _27 = "#3c3c3b";
var _28 = "#373737";
var _29 = "#6a6a69";
var _2a = "#6f6f6f";
var _2b = "#9f9e9e";
var _2c = "#282828";
var _2d = "#828181";
var _2e = "#1d1d1d";
var _2f = "#979797";
var _30 = "#9c9b9b";
var _31 = "#a7a7a6";
var _32 = "#c6c6c5";
var _33 = "#d8d8d7";
var _34 = "#dddddc";
var _35 = "pfx-Account-module__header--AP6zQ";
var _36 = "72px";
var _37 = "40px";
var _38 = "36px";
var _39 = "25px";
var _3a = "18px";
var _3b = "13px";
var _3c = "#0025ff";
var _3d = "rgba(255,255,255,.12)";
var _3e = "#6535f5";
var _3f = "2px";
var _40 = "56px";
var _41 = "56px";
var _42 = "#41ead4";
var _43 = "#f60";
var _44 = "#f83600";
var _45 = "#881f00";
var _46 = "pfx-Account-module__order--h1zIZ";
var _47 = "18px";
var _48 = "15px";
var _49 = "pfx-Account-module__pfx-icon--JB0c5";
var _4a = "red";
var _4b = "pfx-Account-module__root--GMjco";
var _4c = "pfx-Account-module__row--KsH1d";
var _4d = "13px";
var _4e = "rgba(255,255,255,.07)";
var _4f = "pfx-Account-module__table--Q7fe8";
var _50 = "pfx-Account-module__title--nf2PQ";
var _51 = "#35465c";
var _52 = "#55acee";
var _53 = "pfx-Account-module__warning-msg--WmLRh";
var _54 = "#fff";
var _55 = "#ffce36";
var _56 = "#ffcd00";
var _57 = "red";
export { _1 as "accountFields", _2 as "black", _3 as "breakLarge", _4 as "breakMedium", _5 as "breakSmall", _6 as "breakVLarge", _7 as "button", _8 as "containerLarge", _9 as "containerMedium", _a as "containerMobile", _b as "containerPaddingMobile", _c as "containerSmall", _d as "danger", _e as "darkElement", _f as "deleteAccount", _10 as "disabled", _11 as "disabledOpacity", _12 as "download", _13 as "emptyPlaceholder", _14 as "extraLightElement", _15 as "facebook", _16 as "glitchAnim", _17 as "glitchAnim2", _18 as "google", _19 as "green", _1a as "green2", _1b as "greenColor", _1c as "grey1", _1d as "grey10", _1e as "grey2", _1f as "grey25", _20 as "grey27", _21 as "grey3", _22 as "grey33", _23 as "grey3C", _24 as "grey4", _25 as "grey41", _26 as "grey5", _27 as "grey6", _28 as "grey61", _29 as "grey6A", _2a as "grey6F", _2b as "grey7", _2c as "grey8", _2d as "grey82", _2e as "grey9", _2f as "grey97", _30 as "grey9C", _31 as "greyA7", _32 as "greyC6", _33 as "greyD8", _34 as "greyDd", _35 as "header", _36 as "header1", _37 as "header2", _38 as "header3", _39 as "header4", _3a as "header5", _3b as "header6", _3c as "klein", _3d as "lightElement", _3e as "lilac", _3f as "menuBorder", _40 as "menuHeight", _41 as "menuMobileHeight", _42 as "ocean", _43 as "orange", _44 as "orange2", _45 as "orangeDark", _46 as "order", _47 as "paragraph", _48 as "paragraphSmall", _49 as "pfxIcon", _4a as "red", _4b as "root", _4c as "row", _4d as "subHeaderSmall", _4e as "subtleLightElement", _4f as "table", _50 as "title", _51 as "tumblr", _52 as "twitter", _53 as "warningMsg", _54 as "white", _55 as "yellow", _56 as "yellowDeep", _57 as "youtube" }
